import { $, onReady } from '../nth-ms26-core/js/env';

// Menu xổ điện thoại: mở/đóng, Esc để đóng, bấm link thì tự đóng, trả focus về nút menu (bàn phím/trình đọc màn hình)
onReady(() => {
  const btn = $('[data-menu-toggle]');
  const menu = $('#mb-menu');
  if (!btn || !menu) return;
  const root = document.documentElement;

  const set = (open) => {
    root.classList.toggle('has-menu', open);
    btn.setAttribute('aria-expanded', String(open));
    menu.setAttribute('aria-hidden', String(!open));
    if (open) {
      menu.removeAttribute('inert');
      menu.scrollTop = 0;
      const first = menu.querySelector('a, button');
      if (first) setTimeout(() => first.focus({ preventScroll: true }), 300);
    } else {
      menu.setAttribute('inert', '');
    }
  };
  menu.setAttribute('inert', '');

  btn.addEventListener('click', () => {
    const open = !root.classList.contains('has-menu');
    set(open);
    if (!open) btn.focus();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('has-menu')) {
      set(false);
      btn.focus();
    }
  });
  menu.addEventListener('click', (e) => {
    if (e.target.closest('a[href]')) set(false);
  });
  // link tới màn trên trang chủ: đánh dấu mục đang xem
  document.addEventListener('nth:navigate', () => set(false));
});
